mutation resendPendingSubscriptions($input: ResendPendingSubscriptionsInput!) {
  resendPendingSubscriptions(input: $input)
}
